import {Command} from "./Command";
import {PingReturn} from "../model/ping-return";
import cmpConfig from "../../cmp-config";
import cmpStatus from "../../cmp-status";

class PingCommand extends Command {

    public execute(version:number, callback:Function, parameter?:number[]): void {
        const pingReturn:PingReturn = {
            cmpLoaded: cmpStatus.cmpLoaded,
            cmpStatus: cmpStatus.cmpStatus,
            displayStatus: cmpStatus.displayStatus,
            apiVersion: cmpConfig.apiVersion,
            cmpId: cmpStatus.cmpId,
            cmpVersion: cmpStatus.cmpVersion,
            gdprApplies: cmpConfig.gdprApplies,
            gvlVersion: cmpStatus.gvlVersion,
            tcfPolicyVersion: cmpStatus.tfcPolicyVersion
        };
        callback(pingReturn, true);
    }

}

export {PingCommand}
